import { mdInitial, mdFetchUserFulfilled, mdFetchWeighInDetails, mdFetchWeighInDetailsFulfilled, mdTimelineUpdate } from './macroData/'
import { hostDateToString, todayString, daysBetweenDateStrings } from '../views/dashboard/util'
import moment from 'moment';

export const SHOW_OPENING_MODAL_PENDING = 0
export const SHOW_OPENING_MODAL_NONE = 1
export const SHOW_OPENING_MODAL_REMEMBER_TO_CHECK_IN = 2
export const SHOW_OPENING_MODAL_CONSIDER_A_PROFILE_RESET = 3
export const SHOW_OPENING_MODAL_CONSIDER_RESUME = 4
export const SHOW_OPENING_MODAL_WARN_VACATION_EXIT_QUEUE = 5

const userInitial = {
  macroData: mdInitial,
  measurementsData: {},
  billingInfo: { level: 0 },
  showOpeningModal: SHOW_OPENING_MODAL_PENDING,
  daysSinceLastCheckIn: null
}

export default (state=userInitial, action, nextState) => {
  switch(action.type) {
    case 'FETCH_USER':
      state = { ...state, jwt_user_id: action.jwt_user_id, isLoading: true };
      break;
    case 'FETCH_CHECKINS':
      state = { ...state, isLoading: false }
      break
    case 'FETCH_MACROS':
      state = { ...state, isLoading: false }
      break
    case 'FETCH_MACROS_FULFILLED':
      state = { ...state, macros: action.payload, isLoading: false }
      break
    case 'FETCH_USER_FULFILLED':
      let showOpeningModal = SHOW_OPENING_MODAL_NONE
      let daysSinceLastCheckIn = state.daysSinceLastCheckIn
      if (state.showOpeningModal === SHOW_OPENING_MODAL_PENDING) {
        let showingOtherModal = (action.payload.user_guide === 0) || (action.payload.user_intro === 0) || (action.payload.tour_overview === 1)
        switch (action.payload.subscription_status) {
          case 'not yet subscribed':
          case 'ios canceled':
          case 'android canceled':
          case 'canceled via gateway':
          case 'canceled via profile':
          case 'canceled via portal':
          case 'portal payment overdue':
            showingOtherModal = true
            break

          case 'canceled because long past due':
            if (action.payload.decline_type === 'hard') {
              showingOtherModal = true
            }
            break

          case 'portal premium':
          case 'portal basic':
            if (action.payload.portal_user_info.trainer_permission === null) {
              showingOtherModal = true
            }
            break

          default:
        }
        daysSinceLastCheckIn = daysBetweenDateStrings(hostDateToString(action.payload.lastWeighInDate), todayString())

        const daysOnVacation = moment().diff(
          moment.utc(action.payload.vacation_entry_date),
          'days',
        );
        if (!(showingOtherModal || action.payload.vacation_mode)) {
          if (daysSinceLastCheckIn >= 180) {
            showOpeningModal = SHOW_OPENING_MODAL_CONSIDER_A_PROFILE_RESET
          } else if (daysSinceLastCheckIn >= 10) {
            showOpeningModal = SHOW_OPENING_MODAL_REMEMBER_TO_CHECK_IN
          }
        }
        if(action.payload.skip_resume_goal === 0 && action.payload.vacation_mode && daysOnVacation >= 28) {
          showOpeningModal = SHOW_OPENING_MODAL_CONSIDER_RESUME
        }
        if(action.payload.vacation_mode && action.payload.vacation_exit_queue) {
          showOpeningModal = SHOW_OPENING_MODAL_WARN_VACATION_EXIT_QUEUE
        }
      }
      state = { ...state, ...action.payload, show_alert_messages: action.payload.alert_messages.length > 0, macroData: mdFetchUserFulfilled(state.macroData, action.payload), isLoading: false, showOpeningModal, daysSinceLastCheckIn };
      break;
    case 'FETCH_CHECKINS_FULFILLED':
      state = { ...state, weighins: action.payload.check_ins};
      break;
    case 'FETCH_WEIGH_IN_DETAILS':
      state = { ...state, macroData: mdFetchWeighInDetails(state.macroData, action.dateString) };
      break;
    case 'FETCH_WEIGH_IN_DETAILS_FULFILLED':
      state = { ...state, macroData: mdFetchWeighInDetailsFulfilled(state.macroData, action.payload) };
      break;
    case 'FETCH_BILLING':
      state = { ...state, billingInfo: { level: 1 } };
      break;
    case 'FETCH_BILLING_FULFILLED':
      state = { ...state, billingInfo: { level: 2, info: action.payload.info } };
      break;
    case 'FETCH_USER_REJECTED':
      state = { ...state, ...action.payload, isLoading: false };
      break;
    case 'FETCH_CHECKINS_REJECTED':
      state = { ...state, ...action.payload, isLoading: false };
      break;
    case 'MODIFY_USER_FULFILLED':
      state = { ...state, ...action.payload.data, isLoading: false };
      break;
    case 'MODIFY_USER_REJECTED':
      state = { ...state, ...action.payload, isLoading: false };
      break;
    case 'MODIFY_PORTAL_USER_FULFILLED':
      state = { ...state, ...action.payload.data, isLoading: false };
      break;
    case 'MODIFY_PORTAL_USER_REJECTED':
      state = { ...state, ...action.payload, isLoading: false };
      break;
    case 'EDIT_USER_FIELD':
      state = {...state, ...action.payload};
      break;
    case 'CLOSE_OPENING_MODAL':
      state = {...state, showOpeningModal: SHOW_OPENING_MODAL_NONE};
      break;
    case 'LOGOUT':
      state = userInitial;
      break;
    case 'ADD_TIMELINE_ITEM':
    case 'EDIT_TIMELINE_ITEM':
    case 'REMOVE_TIMELINE_ITEM':
      state = { ...state, macroData: mdTimelineUpdate(state.macroData, [action.date], nextState.timeline.timeline) };
      break;
    case 'COPY_TIMELINE_ITEM':
    case 'COPY_TIMELINE_MEAL':
      state = { ...state, macroData: mdTimelineUpdate(state.macroData, action.datesTo, nextState.timeline.timeline) };
      break;
    case 'ALERT_MESSAGES_SHOWN':
      state = { ...state, show_alert_messages: false };
      break;
    case 'COMPLETE_ONBOARDING_LESSON':
      const newOnboarding = [...state.onboarding]
      newOnboarding.push(action.payload)
      
      state = { ...state, onboarding: newOnboarding }
      break;
    case 'ADD_USER_DAILY_WEIGHTS':
      let addDailyWeights = [...state.daily_weights]
      addDailyWeights.push({date: action.payload.date, weight: action.payload.weight})
      state = { ...state, daily_weights: addDailyWeights}
      break;
    case 'MODIFY_USER_DAILY_WEIGHTS':
      let newDailyWeights = [...state.daily_weights]
      let editIndex = newDailyWeights.findIndex(dailyWeight => {
        let compareDate = hostDateToString(dailyWeight.weigh_in_date)
        return (compareDate === action.payload.date)
      })
      newDailyWeights[editIndex].weight = action.payload.weight

      state = { ...state, daily_weights: newDailyWeights}
      break;
    case 'FETCH_MEASUREMENTS_FULFILLED':
      const newMeasurementsData = {
        ...state.measurementsData,
        [action.payload.report_date]: {
          id: action.payload.id,
          report_date: action.payload.report_date,
          user_weight_id: action.payload.user_weight_id,
          data: action.payload.data
        }
      }
      state = { ...state, measurementsData: newMeasurementsData};
      break;
    case 'SAVE_MEASUREMENT_FULFILLED':
      const newData = {...state.measurementsData}
      newData[action.payload.weighinReportDate].data = action.payload.data
      state = { ...state, measurementsData: newData };
      break;
    default: // Do nothing
  }
  return state;
};
